import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { immediateAccess, volumes } from '../data/content';
export function VolumesSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-295" data-mp="cor8yok1ut2p">
      <div className="mx-auto w-full max-w-4xl" data-id="element-296" data-mp="cm510nt8ybjy">
        <p className="text-center text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-297" data-mp="7qhdsdybrsh3">
          What’s inside
        </p>
        <h2 className="mt-4 text-center text-[26px] font-black leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-298" data-mp="3g354tcg4801w">
          6 premium volumes, one continuous workflow
        </h2>

        <div className="mt-10 space-y-5" data-id="element-299" data-mp="3pwm06kvwhn7o">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl border border-navy/10 bg-cream shadow-sm" data-id="element-300" data-mp="3l3j1xzg6hpl5">
              <div className="bg-navy px-5 py-4 sm:px-7 sm:py-5" data-id="element-301" data-mp="2sfx1v165t331">
                <p className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-sky" data-id="element-302" data-mp="2sdkiqkoo0moe">
                  {volume.number}
                </p>
                <h3 className="mt-1.5 text-[19px] font-black uppercase leading-tight text-white sm:text-2xl" data-id="element-303" data-mp="2edtpf6r3akok">
                  {volume.title}
                </h3>
              </div>

              <div className="px-5 py-5 sm:px-7 sm:py-6" data-id="element-304" data-mp="2o4wndzoq2jjm">
                <p className="text-[15px] font-extrabold leading-snug text-cta sm:text-lg" data-id="element-305" data-mp="2o6hgrlzavwfw">
                  {volume.lead}
                </p>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-navy2 sm:text-[15px]" data-id="element-306" data-mp="1vf7njpnr0pjl">
                  {volume.description}
                </p>

                <p className="mt-5 text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-navy2/70" data-id="element-307" data-mp="20gwzd7isp78q">
                  Inside you’ll find:
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-308" data-mp="3bt7h8iw03iye">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-white px-3 py-2.5" data-id="element-309" data-mp="3ftzs1gkitvws">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-310" data-mp="1bsj4ismrldh0" />
                      <span className="text-[13px] font-semibold text-navy sm:text-sm" data-id="element-311" data-mp="1kth5f21wp4vd">
                        {item}
                      </span>
                    </li>)}
                </ul>

                {volume.note ? <p className="mt-5 flex gap-2 rounded-xl border border-navy/10 bg-white px-3.5 py-3 text-[11.5px] leading-relaxed text-navy2/80" data-id="element-312" data-mp="szf84zi5wmip">
                    <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-navy2/60" aria-hidden="true" data-id="element-313" data-mp="120vdgsu4dyg2" />
                    {volume.note}
                  </p> : null}
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-314" data-mp="2kz1i4dpelikx">
          <h3 className="text-center text-[21px] font-black leading-tight text-navy sm:text-3xl" data-id="element-315" data-mp="2kyro8f18mr9y">
            Plus, you’ll get immediate access to:
          </h3>

          <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-316" data-mp="2c1hdcusc145k">
            {immediateAccess.map(item => <li key={item.title} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-cream p-4 sm:p-5" data-id="element-317" data-mp="2gziz5nh57hkq">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-xl shadow-sm" aria-hidden="true" data-id="element-318" data-mp="38p5jsfj1789a">
                  {item.emoji}
                </span>
                <h4 className="mt-3 text-[15px] font-black uppercase tracking-wide text-navy sm:text-base" data-id="element-319" data-mp="2zrlfsytsaxuz">
                  {item.title}
                </h4>
                <p className="mt-1.5 text-[13px] leading-snug text-navy2 sm:text-sm" data-id="element-320" data-mp="1obd8yl7bl0di">
                  {item.text}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 rounded-3xl bg-navy p-6 sm:p-9" data-id="element-321" data-mp="1ys7e4musy95w">
          <p className="text-center text-[22px] font-black leading-tight text-white sm:text-3xl" data-id="element-322" data-mp="1urolwrozz136">
            One case. One blueprint.
            <span className="block text-sky" data-id="element-323" data-mp="1ptn03z06sno0">One structured workflow.</span>
          </p>
          <p className="mt-3 text-center text-[14px] text-white/75 sm:text-base" data-id="element-324" data-mp="2mj4hvccg2062">
            Organize your case map in less than 15 minutes.
          </p>

          <div className="mx-auto mt-7 max-w-md" data-id="element-325" data-mp="2ifeuurbf3qn5">
            <CtaButton variant="onDark" label="Get the complete Blueprint" subLabel="$27 one-time · Lifetime access · Automatic currency conversion" data-id="element-326" data-mp="2dh3lsisy5k5z" />
          </div>
        </div>
      </div>
    </section>;
}